import { generalHelpers, dropHelpers } from '@/_helpers'

const getters = {
  getExportShipment: (state) => {
    return state.shipmentExportDetails
  },
  getSelectedShipmentData: (state) => {
    if (state.selectedShipment != null) {
      return state.selectedShipment
    }
  },
  getIsFetching: (state) => {
    return state.isFetching
  },
  getTransportData: (state) => {
    return state.transport
  },
  getDropTree: (state) => (dropID, applyFilters = true) => {
    let tree = []
    const units = JSON.parse(JSON.stringify(state.dropUnitsHash))
    if (state.dropUnitsHashKeys[dropID] !== undefined) {
      let keys = [...state.dropUnitsHashKeys[dropID]]
      let index = 0
      while (keys.length > index) {
        if (state.dropUnitsHashKeys[keys[index]] !== undefined) {
          keys = generalHelpers.mergeArrays(keys, state.dropUnitsHashKeys[keys[index]], (index + 1))
        }
        ++index
      }
      keys.forEach((key) => {
        if (units[key] !== undefined) {
          if (units[key].parent === dropID) {
            tree.push(units[key])
          } else {
            if (units[units[key].parent] !== undefined) {
              units[units[key].parent].children.push(units[key])
            }
          }
        }
      })
    }
    if (applyFilters) {
      if (state.filteredByOrderRef.length > 0) {
        tree = tree.filter((object) => {
          if (object.items !== null && object.items.length > 0) {
            return state.filteredByOrderRef.indexOf(object.items[0].orderRef) >= 0
          } else {
            return true
          }
        })
      }
      if (state.filteredByCustomerRef.length > 0) {
        tree = tree.filter((object) => {
          if (object.items !== null && object.items.length > 0) {
            return state.filteredByCustomerRef.indexOf(object.transport.order.buyer.ref) >= 0
          } else {
            return true
          }
        })
      }
      if (state.sortedBy !== null) {
        if (state.sortedBy === 'weight') {
          tree.forEach((object) => {
            object['calculatedWeight'] = dropHelpers.calculateUnitWeight(object)
          })
          tree.sort(generalHelpers.compareObjectProperty('calculatedWeight'))
          return tree.sort(generalHelpers.compareObjectPropertyLength('children'))
        } else if (state.sortedBy === 'largest_dimension') {
          tree.forEach((object) => {
            object['largestDimension'] = Math.max(object.dimensions.length, object.dimensions.width, object.dimensions.height)
          })
          tree.sort(generalHelpers.compareObjectProperty('largestDimension'))
          return tree.sort(generalHelpers.compareObjectPropertyLength('children'))
        }
      }
    }
    return tree.sort(generalHelpers.compareObjectPropertyLength('children'))
  },
  getQuoteListExport: (state) => {
    return state.quotes
  },
}
export default getters